import user from './user.js' //用户
import recruitNotice from './recruitNotice.js' //招聘公告
import choosePostRecruitNotice from './choosePostRecruit.js' //招聘公告
import mineRecruit from './mineRecruit.js' //我的招聘
import news from './news.js' //咨询
import code from './code.js' //验证码
import employee from './employee.js' //雇员

import workExperience from "./workExperience.js"//工作经历
import jobPurpose from "./jobPurpose.js"//求职意向
import educationExperience from "./educationExperience.js"//教育经历
import projectExperience from "./projectExperience.js"//项目经历
import append from "./append.js"//附件

import sign from "./sign"//报名

import message from "./message"//消息

import advertisement from "./advertisement"//广告

import post from "./post"//广告

import system from "./system"//系统
import pay from "./pay"//支付
import examination from "./examination"//考试相关
import articleExam from "./articleExam";//文章考试相关
import visit from "./visit"

import enterprise from "./enterprise"

import company from "./company.js"

import ticket from "./ticket.js"
import text from "./text.js" //新考试页面

import courseZ from "./course.js"
import lecturerZ from "./lecturer.js"

import universities from "./universities.js"

export default {
  user,
  recruitNotice,
  choosePostRecruitNotice,
  mineRecruit,
  news,
  code,
  employee,
  workExperience,
  jobPurpose,
  educationExperience,
  projectExperience,
  append,
  sign,
  message,
  advertisement,
  post,
  system,
  pay,
  examination,
  articleExam,
  enterprise,
  company,
  ticket,
  text,
  courseZ,
  lecturerZ,
  visit,
  universities
}



// WEBPACK FOOTER //
// ./src/api/index.js